/**
 * This is only used by ReactionsSection
 * to convert the delivery summary reactions data into a data format easier to render
 * it's in a separate file to keep that main component file clean and easy to read
 */
import type {
  DeliverySummariesFromStream_me_tempStreamItem_MessageItem_reactionSummary_reactions,
  DeliverySummariesFromStream_me_tempStreamItem_MessageItem_reactionSummary_reactions_users,
} from 'chat/queries/__generated__/DeliverySummariesFromStream';

export const organizeData = (
  deliverySummaryReactions: DeliverySummariesFromStream_me_tempStreamItem_MessageItem_reactionSummary_reactions[]
) => {
  const reactions: string[] = [];
  let numReactions = 0;
  const usersAndReactions: {
    [index: string]: {
      user: DeliverySummariesFromStream_me_tempStreamItem_MessageItem_reactionSummary_reactions_users;
      reactions: string[];
    };
  } = {};
  const numPeople = deliverySummaryReactions.reduce((userSet, reaction) => {
    reactions.push(reaction?.name || '');
    reaction.users.forEach((u) => {
      if (!usersAndReactions[u.uuid]) {
        usersAndReactions[u.uuid] = {
          user: u,
          reactions: [],
        };
      }
      usersAndReactions[u.uuid].reactions.push(reaction?.name || '');
      numReactions++;
      userSet.add(u.uuid);
    });
    return userSet;
  }, new Set()).size;
  return { numPeople, numReactions, reactions, usersAndReactions };
};
